import {Component, h, Host, Prop} from '@stencil/core';

@Component({
  tag: 'appleid-signin-button',
  styleUrl: 'appleid-signin-button.scss',
  shadow: true,
})

export class AppleidSigninButton {

  @Prop() langcode = 'en';
  @Prop() ariaLabel = 'Sign in with Apple';

  render() {
    const textLength = this.langcode=='en'?'111.046875':'122.15625';
    return (
      <Host langcode={this.langcode} style={{
          height: '50px',
          cursor: 'pointer'
        }}
            role='button'
            aria-label={this.ariaLabel}
            data-color='black'
            data-border-radius='0'
            data-border='true'
            data-type='sign in'>
        <div class='appleid-signin__button'>
          <div class='appleid-signin__button-inner'>
            <svg xmlns='http://www.w3.org/2000/svg' style={{'pointer-events': 'none', overflow: 'visible'}} width='100%'
                 height='100%'>
              <g>
                <svg xmlns='http://www.w3.org/2000/svg' style={{overflow: 'visible'}} width='100%' height='50%' y='25%'
                     viewBox={'0 -11 '+textLength+' 14'} fill='#fff'>
                  <text font-size='12px'
                        font-family={'applied-button-font-' + this.langcode} direction='ltr'
                        textLength={textLength}
                  > {this.ariaLabel}</text>
                </svg>
              </g>
            </svg>
          </div>
          <div class='appleid-signin__background'>
            <svg xmlns='http://www.w3.org/2000/svg' style={{overflow: 'visible'}} width='100%' height='100%'>
              <rect width='100%' height='100%' ry='0%' fill='#000' stroke='black' stroke-width='1'
                    stroke-linecap='round' />
            </svg>
          </div>
        </div>
      </Host>
    );
  }
}
